module.exports = __webpack_public_path__ + "static/media/slide01.1df1dc13.png";